(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hand-tie-reference-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const cache = new Map();
  const colors = {
    Black: [21,21,21], Red: [223,53,50], 'Blaze Orange': [255,102,18],
    Purple: [126,69,199], Pink: [255,79,154], Yellow: [255,227,34],
    Chartreuse: [217,255,0], Blue: [22,139,233], White: [255,255,255],
    Unpainted: [185,192,197], Shad: [154,164,171], 'Light Blue': [130,209,255]
  };
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const pixels = (url) => {
    if (!cache.has(url)) {
      const promise = (async () => {
        const response = await fetch(url, {mode:'cors', credentials:'omit', headers:{Accept:'image/png'}});
        if (!response.ok) throw new Error('Preview asset unavailable');
        const bitmap = await createImageBitmap(await response.blob());
        const surface = document.createElement('canvas');
        surface.width = bitmap.width;
        surface.height = bitmap.height;
        const ctx = surface.getContext('2d', {willReadFrequently:true});
        if (!ctx) throw new Error('Preview canvas unavailable');
        ctx.drawImage(bitmap, 0, 0);
        bitmap.close();
        return ctx.getImageData(0, 0, surface.width, surface.height);
      })();
      cache.set(url, promise);
      promise.catch(() => cache.delete(url));
    }
    return cache.get(url);
  };
  class HandTieExactArt extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._startFrame = requestAnimationFrame(() => this.start());
    }
    disconnectedCallback() {
      this._connected = false;
      cancelAnimationFrame(this._startFrame);
      cancelAnimationFrame(this._paintFrame);
      this._events?.abort();
    }
    async start() {
      if (!this.isConnected) return;
      this.root = this.closest('hand-tie-builder');
      this.canvas = this.querySelector('canvas');
      this.fallback = this.querySelector('img');
      this.message = this.querySelector('[data-art-error]');
      if (!this.root || !this.canvas || !this.fallback) return;
      this._events?.abort();
      this._events = new AbortController();
      this.root.addEventListener('change', event => {
        if (event.target.matches('[data-color-part], [data-variant-option], [data-silver-flash]')) this.schedule();
      }, {signal:this._events.signal});
      this.setAttribute('aria-busy', 'true');
      try {
        const [source, mask] = await Promise.all([pixels(this.dataset.source), pixels(this.dataset.zones)]);
        if (!this.isConnected) return;
        if (source.width !== mask.width || source.height !== mask.height) throw new Error('Preview size mismatch');
        this.source = source;
        this.mask = mask;
        this.canvas.width = source.width;
        this.canvas.height = source.height;
        this.ctx = this.canvas.getContext('2d');
        if (!this.ctx) throw new Error('Preview canvas unavailable');
        this.output = this.ctx.createImageData(source.width, source.height);
        this.prepareSilverFlash(mask);
        this._lastKey = '';
        this.render();
        this.canvas.hidden = false;
        this.fallback.hidden = true;
        if (this.message) this.message.hidden = true;
        this.dataset.artReady = 'true';
      } catch (error) {
        if (!this.isConnected) return;
        this.dataset.artReady = 'error';
        this.canvas.hidden = true;
        this.fallback.hidden = false;
        if (this.message) this.message.hidden = false;
        console.warn('Hand-tie preview could not load.', error);
      } finally {
        this.setAttribute('aria-busy', 'false');
      }
    }
    schedule() {
      cancelAnimationFrame(this._paintFrame);
      this._paintFrame = requestAnimationFrame(() => this.render());
    }
    prepareSilverFlash(mask) {
      const width = mask.width;
      const height = mask.height;
      const maskCanvas = document.createElement('canvas');
      maskCanvas.width = width;
      maskCanvas.height = height;
      const maskCtx = maskCanvas.getContext('2d');
      const alpha = maskCtx.createImageData(width, height);
      let minX = width, minY = height, maxX = 0, maxY = 0;
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const i = (y * width + x) * 4;
          const tailMask = mask.data[i + 2];
          if (tailMask > 18) {
            alpha.data[i] = 255;
            alpha.data[i + 1] = 255;
            alpha.data[i + 2] = 255;
            alpha.data[i + 3] = Math.min(255, tailMask * 2);
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      maskCtx.putImageData(alpha, 0, 0);
      this.tailMaskCanvas = maskCanvas;
      this.tailBounds = maxX > minX && maxY > minY
        ? {minX, minY, maxX, maxY}
        : {minX: Math.round(width * .39), minY: Math.round(height * .24), maxX: Math.round(width * .96), maxY: Math.round(height * .78)};
      this.flashCanvas = document.createElement('canvas');
      this.flashCanvas.width = width;
      this.flashCanvas.height = height;
      this.flashCtx = this.flashCanvas.getContext('2d');
    }
    drawSilverFlash() {
      if (!this.flashCtx || !this.tailMaskCanvas || !this.tailBounds) return;
      const ctx = this.flashCtx;
      const {minX, minY, maxX, maxY} = this.tailBounds;
      const width = maxX - minX;
      const height = maxY - minY;
      const centerY = minY + height / 2;

      // Silver flash is tied in at the body/tail junction, then fans outward
      // with the same overall spread as the hair or marabou.
      const startX = minX + width * .01;
      const strands = [
        {sy:-.075, c1x:.16, c1y:-.105, c2x:.43, c2y:-.205, ex:.79, ey:-.315},
        {sy:-.050, c1x:.18, c1y:-.072, c2x:.49, c2y:-.145, ex:.86, ey:-.220},
        {sy:-.022, c1x:.20, c1y:-.035, c2x:.55, c2y:-.070, ex:.92, ey:-.095},
        {sy: .022, c1x:.20, c1y: .035, c2x:.55, c2y: .070, ex:.92, ey: .095},
        {sy: .050, c1x:.18, c1y: .072, c2x:.49, c2y: .145, ex:.86, ey: .220},
        {sy: .075, c1x:.16, c1y: .105, c2x:.43, c2y: .205, ex:.79, ey: .315}
      ];

      ctx.clearRect(0, 0, this.flashCanvas.width, this.flashCanvas.height);

      const draw = (lineWidth, strokeStyle) => {
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = strokeStyle;

        strands.forEach(({sy,c1x,c1y,c2x,c2y,ex,ey}) => {
          ctx.beginPath();
          ctx.moveTo(startX, centerY + height * sy);
          ctx.bezierCurveTo(
            minX + width * c1x, centerY + height * c1y,
            minX + width * c2x, centerY + height * c2y,
            minX + width * ex, centerY + height * ey
          );
          ctx.stroke();
        });
      };

      // About 2x thicker than the previous version so the flash reads clearly.
      draw(Math.max(4.3, width * .0064), 'rgba(70,82,90,.46)');

      const shine = ctx.createLinearGradient(startX, centerY, maxX, centerY);
      shine.addColorStop(0, 'rgba(210,220,226,.94)');
      shine.addColorStop(.20, 'rgba(255,255,255,1)');
      shine.addColorStop(.48, 'rgba(171,184,192,.98)');
      shine.addColorStop(.74, 'rgba(255,255,255,1)');
      shine.addColorStop(1, 'rgba(203,215,222,.94)');
      draw(Math.max(2.05, width * .0032), shine);

      // Keep the flash inside the actual hair/marabou tail area.
      ctx.globalCompositeOperation = 'destination-in';
      ctx.drawImage(this.tailMaskCanvas, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      this.ctx.drawImage(this.flashCanvas, 0, 0);
    }
    render() {
      if (!this.source || !this.ctx) return;
      const chosen = part => this.root.querySelector('[data-color-part="'+part+'"]:checked')?.value;
      const head = chosen('head') || 'Black';
      const body = chosen('body') || 'White';
      const tail = chosen('material') || 'Chartreuse';
      const silverFlash = this.root.querySelector('[data-silver-flash]:checked')?.value === 'silver';
      const style = this.root.querySelector('[data-variant-group] [data-variant-option]:checked')?.value || '';
      this.setAttribute('aria-label', [style, this.root.querySelector('.hand-tie-jig-preview__summary')?.textContent].join('. ').replace(/\s+/g,' ').trim());
      const key = [head,body,tail,silverFlash ? 'silver-flash' : 'no-flash'].join('|');
      if (key === this._lastKey) return;
      const hc = colors[head] || colors.Black;
      const bc = colors[body] || colors.White;
      const tc = colors[tail] || colors.Chartreuse;
      const s = this.source.data, m = this.mask.data, out = this.output.data;
      out.set(s);
      for (let i=0; i<s.length; i+=4) {
        if (m[i] && head !== 'Black') {
          const weight = m[i]/255;
          for (let c=0;c<3;c++) out[i+c] = Math.round(s[i+c] + weight*(1-s[i+c]/255)*hc[c]);
        } else if (m[i+1] && body !== 'White') {
          const weight = m[i+1]/255;
          for (let c=0;c<3;c++) out[i+c] = Math.round(s[i+c] + weight*(s[i+c]*bc[c]/255-s[i+c]));
        } else if (m[i+2] && tail !== 'Chartreuse') {
          const alpha = clamp((255-s[i+2])/255,1/255,1);
          const white = 255*(1-alpha);
          const r = clamp((s[i]-white)/alpha,0,255);
          const g = clamp((s[i+1]-white)/alpha,0,255);
          const b = clamp((s[i+2]-white)/alpha,0,255);
          const tone = alpha > .25 ? clamp((.2126*r+.7152*g+.0722*b)/227,.86,1) : .99;
          for (let c=0;c<3;c++) out[i+c] = Math.round(white + alpha*tone*tc[c]);
        }
      }
      this.ctx.putImageData(this.output,0,0);
      if (silverFlash) this.drawSilverFlash();
      this._lastKey = key;
    }
  }
  if (!customElements.get('hand-tie-exact-art')) customElements.define('hand-tie-exact-art', HandTieExactArt);
})();
  } catch(e) { console.error(e); }
})();

})();
